import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { useParams } from 'react-router-dom'

import { Order } from '../features/order/components'
import FallbackErrorMessage from '../utils/errors/FallbackMessage'

export const OrderPage: React.FC = () => {
  const { id } = useParams()

  return (
    <ErrorBoundary FallbackComponent={FallbackErrorMessage}>
      <Order id={id as string} />
    </ErrorBoundary>
  )
}
